/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateKpiDefinitionRequestBody
 */
export interface UpdateKpiDefinitionRequestBody {
    /**
     * 
     * @type {string}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    unit?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    direction?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    targetValue?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    warningValue?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    breachValue?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    sourceModule?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    sourceRef?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateKpiDefinitionRequestBody
     */
    notes?: string;
}

/**
 * Check if a given object implements the UpdateKpiDefinitionRequestBody interface.
 */
export function instanceOfUpdateKpiDefinitionRequestBody(value: object): value is UpdateKpiDefinitionRequestBody {
    return true;
}

export function UpdateKpiDefinitionRequestBodyFromJSON(json: any): UpdateKpiDefinitionRequestBody {
    return UpdateKpiDefinitionRequestBodyFromJSONTyped(json, false);
}

export function UpdateKpiDefinitionRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateKpiDefinitionRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'displayName': json['displayName'] == null ? undefined : json['displayName'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'direction': json['direction'] == null ? undefined : json['direction'],
        'targetValue': json['targetValue'] == null ? undefined : json['targetValue'],
        'warningValue': json['warningValue'] == null ? undefined : json['warningValue'],
        'breachValue': json['breachValue'] == null ? undefined : json['breachValue'],
        'sourceModule': json['sourceModule'] == null ? undefined : json['sourceModule'],
        'sourceRef': json['sourceRef'] == null ? undefined : json['sourceRef'],
        'active': json['active'] == null ? undefined : json['active'],
        'notes': json['notes'] == null ? undefined : json['notes'],
    };
}

export function UpdateKpiDefinitionRequestBodyToJSON(json: any): UpdateKpiDefinitionRequestBody {
    return UpdateKpiDefinitionRequestBodyToJSONTyped(json, false);
}

export function UpdateKpiDefinitionRequestBodyToJSONTyped(value?: UpdateKpiDefinitionRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'displayName': value['displayName'],
        'unit': value['unit'],
        'direction': value['direction'],
        'targetValue': value['targetValue'],
        'warningValue': value['warningValue'],
        'breachValue': value['breachValue'],
        'sourceModule': value['sourceModule'],
        'sourceRef': value['sourceRef'],
        'active': value['active'],
        'notes': value['notes'],
    };
}

